import type { BootstrapVariables, SearchVariables } from '../../../common/constants/relay/types';

// Gets the variables for the bootstrap state.
export const getBootstrapVariables = (b: BootstrapVariables): BootstrapVariables => {
	return {
		cloudId: b.cloudId,
		primaryProduct: b.primaryProduct,
		searchSessionId: b.searchSessionId,
		isRovoEnabled: b.isRovoEnabled,
		allFilterExcludedProducts: b.allFilterExcludedProducts,
		thirdPartyConfigs: b.thirdPartyConfigs,
		experimentConfig: b.experimentConfig,
		experimentLayers: b.experimentLayers,
		products: b.products,
		isJiraIssueIndexed: b.isJiraIssueIndexed,
		user: b.user,
		nouns: b.nouns,
		isNounsAvailable: b.isNounsAvailable,
		referrer: b.referrer,
		productDataRegions: b.productDataRegions,
		productEdition: b.productEdition,
		overrides: b.overrides,
	};
};

// Gets the variables for the search state.
export const getSearchVariables = (s: SearchVariables): SearchVariables => {
	return {
		searchQuery: s.searchQuery,
		originalQuery: s.originalQuery,
		resultsSort: s.resultsSort,
		filters: s.filters,
		selectedProducts: s.selectedProducts,
		selectedDatasource: s.selectedDatasource,
		jsmIncidentFilterIds: s.jsmIncidentFilterIds,
		paginationTokens: s.paginationTokens,
		availableProducts: s.availableProducts,
		requestId: s.requestId,
		traceId: s.traceId,
		cql: s.cql,
	};
};
